/**
 * scaleUtils.js
 * ----------------------------------------------------------------------------
 * Conversão entre a "fonte da verdade" (metros) e a camada visual (pixels).
 *
 * A ficha técnica guarda tudo em metros (ex: comprimento 2.40, largura 0.60).
 * O desenho 2D precisa de pixels. Esta camada centraliza essa conversão para
 * que nenhuma outra parte do componente "chute" valores de escala.
 *
 * PONTO DE EXTENSÃO FUTURO:
 *  - Suporte a displayUnit em cm/mm: basta multiplicar/dividir aqui.
 *  - Escala dinâmica (fit-to-canvas) calculada a partir do bounding box total.
 */

// 1 metro = 120px por padrão (definição visual, não financeira).
export const DEFAULT_METERS_TO_PX = 120;

/**
 * Converte metros para pixels usando a escala visual.
 * @param {number} meters
 * @param {number} scale fator multiplicador de zoom/escala (default 1)
 * @param {number} base px por metro (default DEFAULT_METERS_TO_PX)
 */
export function metersToPx(meters, scale = 1, base = DEFAULT_METERS_TO_PX) {
  const value = Number(meters) || 0;
  return value * base * scale;
}

/**
 * Converte pixels de volta para metros. Usado ao arrastar/redimensionar,
 * garantindo que a fonte da verdade continue em metros.
 * @param {number} px
 * @param {number} scale
 * @param {number} base
 */
export function pxToMeters(px, scale = 1, base = DEFAULT_METERS_TO_PX) {
  const value = Number(px) || 0;
  const divisor = base * scale || 1;
  return value / divisor;
}
